import { isFunction } from 'lodash'
import { onBeforeUnmount, onMounted, ref, useTemplateRef } from 'vue'

import { NOTIFICATION_ATTRIBUTES } from '@/utils/in-app-notifications'

export const useMarkAsRead = ({ item, callback, templateRef = '' } = {}) => {
  const observer = ref(null)
  const wrapperReference = useTemplateRef(templateRef) || null

  const initIntersectionObserver = () => {
    observer.value = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            if (isFunction(callback)) {
              callback()
            }
            destroyIntersectionObserver()
          }
        })
      },
      {
        threshold: 1
      }
    )
    observer.value.observe(wrapperReference.value)
  }

  const destroyIntersectionObserver = () => {
    observer.value.disconnect()
    observer.value = null
  }

  onMounted(() => {
    if (!item.isRead && wrapperReference.value) {
      initIntersectionObserver()
    }
  })

  onBeforeUnmount(() => {
    if (observer.value) {
      destroyIntersectionObserver()
    }
  })

  return {
    wrapperReference
  }
}

export const getNotificationElementEntity = normalizedAttributes => {
  const { ELEMENT_TYPE_ID, ELEMENT_LEVEL_PREFIX, ELEMENT_LEVEL_COLOR, WORKSPACE_ID, ELEMENT_ID } =
    NOTIFICATION_ATTRIBUTES

  const okrElement = {
    typeId: normalizedAttributes[ELEMENT_TYPE_ID],
    levelPrefix: normalizedAttributes[ELEMENT_LEVEL_PREFIX],
    levelColor: normalizedAttributes[ELEMENT_LEVEL_COLOR],
    workspaceId: normalizedAttributes[WORKSPACE_ID],
    id: normalizedAttributes[ELEMENT_ID]
  }

  return {
    okrElement
  }
}
